// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/rfi_feedback.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AdoptRfiFeedbackRequest, AdoptRfiFeedbackResponse, GetRfiFeedbackHistoryRequest, GetRfiFeedbackHistoryResponse, ListProposalRfiHistoryRequest, ListProposalRfiHistoryResponse, ListRfiFeedbackTargetsRequest, ListRfiFeedbackTargetsResponse, RecordRfiFeedbackVersionRequest, RecordRfiFeedbackVersionResponse } from "./rfi_feedback_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { CheckRfiFeedbackAccessRequest, CheckRfiFeedbackAccessResponse } from "../../datagateway/v1/rfi_feedback_pb";
/**
 * Tenant, actor and timestamps always come from the authenticated principal.
 *
 * @generated from service mono.projectdata.v1.RfiFeedbackService
 */ export const RfiFeedbackService = {
    typeName: "mono.projectdata.v1.RfiFeedbackService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.RfiFeedbackService.RecordRfiFeedbackVersion
     */ recordRfiFeedbackVersion: {
            name: "RecordRfiFeedbackVersion",
            I: RecordRfiFeedbackVersionRequest,
            O: RecordRfiFeedbackVersionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiFeedbackService.AdoptRfiFeedback
     */ adoptRfiFeedback: {
            name: "AdoptRfiFeedback",
            I: AdoptRfiFeedbackRequest,
            O: AdoptRfiFeedbackResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiFeedbackService.GetRfiFeedbackHistory
     */ getRfiFeedbackHistory: {
            name: "GetRfiFeedbackHistory",
            I: GetRfiFeedbackHistoryRequest,
            O: GetRfiFeedbackHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiFeedbackService.ListProposalRfiHistory
     */ listProposalRfiHistory: {
            name: "ListProposalRfiHistory",
            I: ListProposalRfiHistoryRequest,
            O: ListProposalRfiHistoryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.RfiFeedbackService.ListRfiFeedbackTargets
     */ listRfiFeedbackTargets: {
            name: "ListRfiFeedbackTargets",
            I: ListRfiFeedbackTargetsRequest,
            O: ListRfiFeedbackTargetsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Authorization only: must never load feedback history (including on callbacks).
     *
     * @generated from rpc mono.projectdata.v1.RfiFeedbackService.CheckRfiFeedbackAccess
     */ checkRfiFeedbackAccess: {
            name: "CheckRfiFeedbackAccess",
            I: CheckRfiFeedbackAccessRequest,
            O: CheckRfiFeedbackAccessResponse,
            kind: MethodKind.Unary
        }
    }
};
